module.exports = __webpack_public_path__ + "palo-sunlogo-4060bf880636dc77ed13.svg";